/* eslint-disable  @typescript-eslint/no-explicit-any */

import {
    getFromLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'
import { request } from './apiClient'

interface GetWithAuthResponse {
    response: any // The data returned from the server
    maxAge: string | null | undefined // Cache control `max-age` header
    eTag: string | null | undefined // ETag header
    requestTime: number // Timestamp of the request
}

export const putWithAuth = async (
    route: string,
    includeBaseUrl?: boolean,
    body?: string,
    profileId?: string
) => {
    const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
    const response = await request(
        'PUT',
        route,
        sessionToken,
        includeBaseUrl,
        body,
        profileId
    )
    return response
}

export const get = async (route: string, includeBaseUrl?: boolean) => {
    const response = await request('GET', route, undefined, includeBaseUrl)
    return response
}

export const getWithAuth = async (
    route: string,
    includeBaseUrl = true,
    queryParams?: Record<string, string | number | boolean>,
    headers?: object
): Promise<GetWithAuthResponse | undefined> => {
    const queryString = queryParams
        ? `${new URLSearchParams(
              queryParams as Record<string, string>
          ).toString()}`
        : ''

    // Append query string to the route
    const urlWithParams = `${route}${queryString}`

    const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
    const { jsonData, maxAge, eTag, requestTime } = await request(
        'GET',
        urlWithParams,
        sessionToken,
        includeBaseUrl,
        undefined,
        undefined,
        headers
    )

    return {
        response: jsonData,
        maxAge,
        eTag,
        requestTime,
    }
}

export const post = async (
    route: string,
    includeBaseUrl?: boolean,
    body?: string
) => {
    const response = await request(
        'POST',
        route,
        undefined,
        includeBaseUrl,
        body
    )
    return response
}

export const postWithAuth = async (
    route: string,
    includeBaseUrl?: boolean,
    body?: string,
    profileId?: string
) => {
    const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
    const { jsonData: response } = await request(
        'POST',
        route,
        sessionToken,
        includeBaseUrl,
        body,
        profileId
    )
    return response
}

export const deleteWithAuth = async (
    route: string,
    includeBaseUrl?: boolean,
    body?: string,
    profileId?: string
) => {
    const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
    const response = await request(
        'DELETE',
        route,
        sessionToken,
        includeBaseUrl,
        body,
        profileId
    )
    return response
}
